import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { stackClientApp } from '../stackClient';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasHandledRef = useRef(false);

  useEffect(() => {
    // prevent double-run in React.StrictMode
    if (hasHandledRef.current) return;
    hasHandledRef.current = true;

    const handleCallback = async () => {
      // console.log('[AuthCallback] mounted, URL =', window.location.href);

      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');

        let user = null;

        if (code && state) {
          // console.log(
          //   '[AuthCallback] Found code & state, calling callOAuthCallback'
          // );

          const success = await stackClientApp.callOAuthCallback();
          // console.log('[AuthCallback] callOAuthCallback success:', success);

          if (success) {
            user = await stackClientApp.getUser();
            // console.log('[AuthCallback] getUser() after callback:', user);
          } else {
            console.warn(
              '[AuthCallback] callOAuthCallback returned false, no session created'
            );
          }
        } else {
          // console.log(
          //   '[AuthCallback] No code/state, calling getUser directly (maybe existing session)'
          // );
          user = await stackClientApp.getUser();
          // console.log('[AuthCallback] getUser() result:', user);
        }

        if (user) {
          const authJson = await user.getAuthJson();
          // console.log('[AuthCallback] authJson:', authJson);

          const accessToken = authJson.accessToken;
          const name = user.displayName || user.primaryEmail || 'friend';

          localStorage.setItem('stack_access_token', accessToken);
          localStorage.setItem('stack_user_id', user.id);
          localStorage.setItem('user_email', user.primaryEmail || '');
          localStorage.setItem('name', name);

          // console.log('[AuthCallback] Stored in localStorage:', {
          //   stack_access_token: localStorage.getItem('stack_access_token'),
          //   name: localStorage.getItem('name'),
          // });
        } else {
          console.warn(
            '[AuthCallback] No user returned even after callOAuthCallback/getUser'
          );
        }
      } catch (err) {
        console.error('[AuthCallback] Error handling auth callback:', err);
      } finally {
        navigate('/frontpage', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-headergreen">
      <p className="text-white text-lg">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
